<template>
  <div id="authentication">
    <header>
      <div class="content">
        <span>欢迎使用中资云企业综合服务平台</span>
      </div>
    </header>
    <section class="content">
      <div class="title flex-between-center">
        <div class="left flex-align-center">
          <img src="../assets/imgs/authentication/logo.png" alt />
          <h2>企业{{ titleName }}</h2>
        </div>
        <span @click="goHome">平台首页</span>
      </div>
      <!-- 步骤条 -->
      <div class="progress flex-between">
        <div class="backBox">
          <Icon type="ios-arrow-back" />
          <span @click="back">返回</span>
        </div>
        <div class="item" :class="step == 1 ? 'active' : ''" @click="clickTap(1)">
          <div class="step" v-show="step == 1">1</div>
          <div class="stepFinish" v-show="step != 1">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>企业详细信息</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step == 2 ? 'active' : ''" @click="clickTap(2)">
          <div class="step" v-show="step == 1 || step == 2">2</div>
          <div class="stepFinish" v-show="step == 3">
            <img src="../assets/imgs/register/finshed.png" alt />
          </div>
          <span>联系人信息</span>
        </div>
        <div class="line">
          <img src="../assets/imgs/register/line.png" alt />
        </div>
        <div class="item" :class="step == 3 ? 'active' : ''" @click="clickTap(3)">
          <div class="step">3</div>
          <span>完成</span>
        </div>
      </div>
      <!-- 内容 -->
      <div class="progressBox" v-if="step == 1">
        <p class="head">企业详细信息</p>
        <div class="progressContent">
          <Form ref="information" :model="information" :rules="ruleValidate">
            <!-- <FormItem label="企业营业执照" prop="license" style="width:440px"> -->
            <div class="contractBox">
              <span style="color: red; margin-right: 8px; font-size: 15px">*</span>
              <span style="font-size: 14px; color: #b3b8c4; position: relative; top: -3px">企业营业执照</span>
              <Button style="background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%); border: 1px solid #4c9b25; border-radius: 4px; color: white; width: 117px; height: 26px; margin-left: 16.5px; margin-bottom: 8px" @click="showModal2">手机上传</Button>
              <Upload :action="this.$baseUrl" :before-upload="handleUpload">
                <Button style="background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%); border: 1px solid #285ed3; border-radius: 4px; color: white; width: 117px; height: 26px; margin-left: 16.5px">本地上传</Button>
              </Upload>
              <!-- <span style="margin-left: 16.5px;margin-bottom: 8px;color: #2C59C3;font-size: 12px;">共{{imgArr.length}}张照片</span> -->
            </div>
            <div class="license">
              <img v-show="!imgArr" src="../assets/imgs/authentication/license.png" alt class="noImg" />
              <img v-show="imgArr" @click="gobig(fileCommonUrl + imgArr)" :src="fileCommonUrl + imgArr" alt class="noImg" />
            </div>
            <p class="msg">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</p>
            <!-- </FormItem> -->
            <div class="flex-between-center" style="margin-top: 10px">
              <div>
                <FormItem label="企业名称" prop="enterpriseName">
                  <Input type="text" disabled v-model="information.enterpriseName" placeholder="请输入企业名称"></Input>
                </FormItem>
              </div>
              <div class="flex">
                <div>
                  <FormItem label="所属地区" prop="orgName" style="width: 157px">
                    <Input type="text" disabled v-model="information.orgName" placeholder="请输入所属地区"></Input>
                  </FormItem>
                </div>
                <div>
                  <FormItem label="所属乡镇" prop="ownerTown" style="width: 200px; margin-left: 8px">
                    <Select v-model="information.ownerTown">
                      <Option v-for="item in cityList" :value="item.id ? item.id : ''" :key="item.id">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                </div>
              </div>
            </div>
            <div class="flex-between-center">
              <FormItem label="统一社会信用代码" prop="blNum">
                <Input type="text" disabled v-model="information.blNum" placeholder="请输入统一社会信用代码"></Input>
              </FormItem>
              <FormItem label="企业性质" prop="enterpriseType">
                <Select v-model="information.enterpriseType">
                  <Option v-for="item in enterpriseTypeList" :value="item.code" :key="item.i">{{ item.name }}</Option>
                </Select>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="注册资金（万元）" prop="regFund">
                <Input type="text" v-model="information.regFund" placeholder="请输入注册资金"></Input>
              </FormItem>
              <FormItem label="注册日期" prop="regDate">
                <DatePicker type="date" placeholder="…请选择注册日期…" v-model="information.regDate"></DatePicker>
              </FormItem>
            </div>
            <FormItem label="企业地址" prop="address" style="width: 100%">
              <Input type="text" v-model="information.address" placeholder="请输入企业地址"></Input>
            </FormItem>
            <div class="flex-between-center">
              <FormItem label="开户行" prop="bankId">
                <Select v-model="information.bankId" filterable>
                  <Option v-for="item in bankList" :value="item.code" :key="item.i" placeholder="请选择开户行">{{ item.name }} </Option>
                </Select>
              </FormItem>
              <FormItem label="银行账号" prop="bankAccount">
                <Input type="text" v-model="information.bankAccount" placeholder="请输入银行账号"></Input>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="中原银行商户号" prop="zybankMerId">
                <Input type="text" v-model="information.zybankMerId" placeholder="请输入中原银行商户号"></Input>
              </FormItem>
              <FormItem label="邮编" prop="postalCode">
                <Input type="text" v-model="information.postalCode" placeholder="请输入邮编号码"></Input>
              </FormItem>
            </div>
            <div class="flex-between-center">
              <FormItem label="传真" prop="fax">
                <Input type="text" v-model="information.fax" placeholder="请输入传真号码"></Input>
              </FormItem>
              <FormItem label="邮箱">
                <Input type="text" v-model="information.ext2" placeholder="请输入企业邮箱"></Input>
              </FormItem>
            </div>
            <FormItem label="企业网址" prop="enterpriseWeb" style="width: 100%">
              <Input type="text" v-model="information.enterpriseWeb" placeholder="请输入企业网址"></Input>
            </FormItem>
            <FormItem label="企业简介" prop="enterpriseProfile" style="width: 100%">
              <Input v-model="information.enterpriseProfile" type="textarea" :autosize="{ minRows: 4, maxRows: 5 }" placeholder="请输入企业简介"></Input>
            </FormItem>
            <Button type="primary" @click="handleSubmit('information')" class="next">下一步</Button>
          </Form>
        </div>
      </div>
      <div class="progressBox" v-show="step == 2">
        <p class="head">联系人信息</p>
        <div class="progressContent">
          <Form ref="contactsInfo" :model="contactsInfo" :rules="ruleContacts">
            <div class="flex-between-center">
              <FormItem label="联系人姓名" prop="cpName">
                <Input type="text" v-model="contactsInfo.cpName" placeholder="请输入联系人姓名"></Input>
              </FormItem>
              <FormItem label="联系人电话" prop="cpPhone" style="margin-left: 20px">
                <Input type="text" v-model="contactsInfo.cpPhone" placeholder="请输入联系人电话"></Input>
              </FormItem>
            </div>
            <FormItem label="联系人身份证号" prop="cpCardId">
              <Input type="text" v-model="contactsInfo.cpCardId" placeholder="请输入联系人身份证号"></Input>
            </FormItem>
            <div class="flex-between-center">
              <FormItem label="法人姓名" prop="lpName">
                <Input type="text" v-model="contactsInfo.lpName" placeholder="请输入法人姓名"></Input>
              </FormItem>
              <FormItem label="法人电话" prop="lpPhone">
                <Input type="text" v-model="contactsInfo.lpPhone" placeholder="请输入法人电话"></Input>
              </FormItem>
            </div>
            <FormItem label="法人身份证号" prop="lpCardId">
              <Input type="text" v-model="contactsInfo.lpCardId" placeholder="请输入法人身份证号"></Input>
            </FormItem>
            <div class="imgBox">
              <div class="imgMsg">
                <span class="txt">附件上传</span>
                <Button type="success" class="upload" @click="showModal2">手机上传</Button>
              </div>
              <div class="flex-between-center marign15">
                <div>
                  <div class="flex-align-center">
                    <p>
                      <span class="must">*</span>
                      <span>联系人身份证正面</span>
                    </p>
                    <Upload :action="this.$baseUrl" :before-upload="uploadcpCardFront">
                      <Button class="uploadBut">本地上传</Button>
                    </Upload>
                  </div>
                  <div class="license">
                    <img src="../assets/imgs/authentication/license.png" alt class="noImg" v-show="!cpCardFrontImgUrl" />
                    <img :src="cpCardFrontImgUrl" class="noImg" alt="" v-show="cpCardFrontImgUrl" @click="gobig(cpCardFrontImgUrl)" />
                  </div>
                  <p class="msg">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</p>
                </div>
                <div>
                  <div class="flex-align-center">
                    <p>
                      <span class="must">*</span>
                      <span>联系人身份证反面</span>
                    </p>
                    <Upload :action="this.$baseUrl" :before-upload="uploadcpCardRearImg">
                      <Button class="uploadBut">本地上传</Button>
                    </Upload>
                  </div>
                  <div class="license">
                    <img src="../assets/imgs/authentication/license.png" alt class="noImg" v-show="!cpCardRearImgUrl" />
                    <img :src="cpCardRearImgUrl" class="noImg" alt="" v-show="cpCardRearImgUrl" @click="gobig(cpCardRearImgUrl)" />
                  </div>
                  <p class="msg">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</p>
                </div>
              </div>
              <div class="flex-between-center marign15">
                <div>
                  <div class="flex-align-center">
                    <p>
                      <span class="must">*</span>
                      <span>法人身份证正面</span>
                    </p>
                    <Upload :action="this.$baseUrl" :before-upload="uploadlpCardFrontImg">
                      <Button class="uploadBut">本地上传</Button>
                    </Upload>
                  </div>
                  <div class="license">
                    <img src="../assets/imgs/authentication/license.png" alt class="noImg" v-show="!lpCardFrontImgUrl" />
                    <img :src="lpCardFrontImgUrl" alt class="noImg" v-show="lpCardFrontImgUrl" @click="gobig(lpCardFrontImgUrl)" />
                  </div>
                  <p class="msg">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</p>
                </div>
                <div>
                  <div class="flex-align-center">
                    <p>
                      <span class="must">*</span>
                      <span>法人身份证反面</span>
                    </p>
                    <Upload :action="this.$baseUrl" :before-upload="uploadlpCardRearImg">
                      <Button class="uploadBut">本地上传</Button>
                    </Upload>
                  </div>
                  <div class="license">
                    <img src="../assets/imgs/authentication/license.png" alt class="noImg" v-show="!lpCardRearImgUrl" />
                    <img :src="lpCardRearImgUrl" alt class="noImg" v-show="lpCardRearImgUrl" @click="gobig(lpCardRearImgUrl)" />
                  </div>
                  <p class="msg">要求照片/扫描件内容清晰完整，无反光，露出四个边角，文件大小2M以内</p>
                </div>
              </div>
            </div>
            <div class="submitBox">
              <Button class="backBut" v-show="step == 2" @click="clickTap(1)">上一步</Button>
              <Button type="primary" class="sbumit" @click="submit">提交认证</Button>
            </div>
          </Form>
        </div>
      </div>
      <div class="progressBox" v-if="step == 3">
        <div class="completeBox">
          <div class="flex-align-center completeTitle">
            <img src="../assets/imgs/authentication/complete.png" alt />
            <h2>企业{{ titleName }}资料提交成功！</h2>
          </div>
          <div class="completeContent">
            <div class="textBox">
              <h3>请您于5个工作日内携带以下相关资料及物品，前往所属市县交易中心现场办理：</h3>
              <div class="completeTxt">
                <p>1：企业营业执照、法人身份证、经办人身份证、经办人委托书、销售合同、企业公章、乡镇政府证明原件及复印件（复印件需加盖公章）；</p>
                <p>2：企业公章；</p>
                <p>3；支撑版本4.0以上安卓系统手机一部。</p>
              </div>
            </div>
            <div class="reduce">
              <span>{{ time }}</span>
              <span>秒后系统自动跳转</span>
            </div>
            <Button class="back" @click="back">返回</Button>
          </div>
        </div>
      </div>
    </section>
    <foot></foot>
    <!-- 手机下载 -->
    <Modal v-model="modal2" width="480" class-name="vertical-center-modal">
      <p slot="header" style="text-align: center">
        <span style="color: white; font-size: 18px; font-weight: 600">手机上传</span>
      </p>
      <div style="justify-content: center; display: flex">
        <div ref="qrcodeDiv"></div>
      </div>
      <div slot="footer" style="text-align: center">
        <span>微信扫描二维码上传照片</span>
      </div>
    </Modal>
    <!-- 查看营业执照大图 -->
    <!-- 查看大图 -->
    <vue-viewer ref="myViewer" className="my_class" :visible.sync="isShowBig" :images="bigUrl"></vue-viewer>
  </div>
</template>

<script>
import foot from '../components/footer';
import QRCode from 'qrcodejs2';
import vueViewer from '../components/bigImg/Viewer.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
const idCardPass = (rule, value, callback) => {
  let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value === '') {
    callback(new Error('身份证号不能为空'));
  } else if (!reg.test(value)) {
    callback(new Error('请输入正确的身份证号'));
  } else {
    callback();
  }
};
let timeId;
export default {
  data() {
    return {
      titleName: '认证',
      time: 3,
      session: '',
      step: 1,
      isShowBig: false,
      bigUrl: [],
      cityList: [],
      information: {
        bankId: '',
        bankAccount: '',
        address: ''
      }, //企业信息
      contactsInfo: {
        cpName: '',
        cpPhone: '',
        cpCardId: '',
        lpName: '',
        lpPhone: '',
        lpCardId: ''
      }, //联系人信息
      ruleValidate: {
        enterpriseName: [
          {
            required: true,
            message: '企业名称不能为空',
            trigger: 'blur'
          }
        ],
        orgName: [
          {
            required: true,
            message: '所属地区不能为空',
            trigger: 'blur'
          }
        ],
        ownerTown: [
          {
            required: true,
            message: '所属地区不能为空',
            trigger: 'change'
          }
        ],
        blNum: [
          {
            required: true,
            message: '统一社会信用代码不能为空',
            trigger: 'blur'
          }
        ],
        enterpriseType: [
          {
            required: true,
            message: '企业性质不能为空',
            trigger: 'change'
          }
        ],
        regFund: [
          {
            required: true,
            message: '企业性质不能为空',
            trigger: 'blur'
          }
        ],
        regDate: [
          {
            required: true,
            // type:"date",
            message: '注册日期不能为空',
            trigger: 'change',
            pattern: /.+/
          }
        ],
        bankId: [
          {
            required: true,
            message: '开户行不能为空',
            trigger: 'blur'
          }
        ],
        bankAccount: [
          {
            required: true,
            message: '银行账号不能为空',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '企业地址不能为空',
            trigger: 'blur'
          }
        ]
      },
      ruleContacts: {
        cpName: [
          {
            required: true,
            message: '联系人姓名不能为空',
            trigger: 'blur'
          }
        ],
        cpPhone: [
          {
            required: true,
            message: '联系人电话不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        cpCardId: [
          {
            required: true,
            validator: idCardPass,
            trigger: 'blur'
          }
        ],
        lpName: [
          {
            required: true,
            message: '法人姓名不能为空',
            trigger: 'blur'
          }
        ],
        lpPhone: [
          {
            required: true,
            message: '法人电话不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        lpCardId: [
          {
            required: true,
            validator: idCardPass,
            trigger: 'blur'
          }
        ]
      },
      phoneUp: true,
      modal2: false,
      imgArr: '',
      enterpriseTypeList: [],
      bgImg: false,
      cpCardFrontImgUrl: '',
      cpCardRearImgUrl: '',
      lpCardFrontImgUrl: '',
      lpCardRearImgUrl: '',
      fileCommonUrl: '',
      bankList: [],
      websock: null,
      lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      websockHeart: true
    };
  },
  components: {
    foot,
    vueViewer
  },
  created() {
    var session = JSON.parse(localStorage['session']);
    this.fileCommonUrl = localStorage.getItem('fileCommonUrl');
    let name = localStorage['titleName'];
    if (name) {
      this.titleName = name;
    }
    this.session = session;
    this.information.enterpriseName = this.session.enterpriseName;
    this.getCompanyData();
    this.init();
  },
  destroyed() {
    var self = this;
    self.timeoutObj && clearTimeout(self.timeoutObj);
    self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
    this.websockHeart = false;
  },
  methods: {
    ...mapMutations(['setContentType', 'setMenuName']),
    clickTap(index) {
      if (this.step == 2) {
        //step=2时可以切1
        if (index == 1) {
          this.information.regDate = new Date(this.information.regDate);
          this.step = 1;
        }
      }
    },
    goHome() {
      window.sessionStorage.removeItem('from');
      this.setContentType(0);
      this.$router.push('/home');
    },
    goBack() {
      this.$router.push('/home');
    },
    back() {
      window.sessionStorage.setItem('from', '企业资料');
      this.$router.push('/home');
      clearInterval(timeId);
    },

    init() {
      let url = localStorage.getItem('uploadFileSocketUrl') + '/' + this.session.sessionId; // 创建websocket连接
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websockOpen; // 监听打开
      this.websock.onclose = this.websockClose; // 监听关闭
      this.websock.onerror = this.websockError; //监听异常
      this.websock.onmessage = this.websockMessage; //监听服务器发送的消息
    },
    websockOpen() {
      // console.log("监听打开");
      //开启心跳
      this.start();
    },
    websockClose() {
      //重连
      if (this.websockHeart) {
        this.reconnect();
      }
    },
    websockError() {
      // console.log("监听异常");
      //重连
      this.reconnect();
    },
    websockMessage(e) {
      let obj = JSON.parse(e.data);
      if (this.step == 1) {
        this.imgArr = obj.msg;
        this.modal2 = false;
      }
      if (this.step == 2) {
        let img = JSON.parse(obj.msg);
        this.contactsInfo.cpCardFrontImg = img.cpCardFrontImg;
        this.cpCardFrontImgUrl = this.fileCommonUrl + img.cpCardFrontImg;
        this.contactsInfo.cpCardRearImg = img.cpCardRearImg;
        this.cpCardRearImgUrl = this.fileCommonUrl + img.cpCardRearImg;
        this.contactsInfo.lpCardFrontImg = img.lpCardFrontImg;
        this.lpCardFrontImgUrl = this.fileCommonUrl + img.lpCardFrontImg;
        this.contactsInfo.lpCardRearImg = img.lpCardRearImg;
        this.lpCardRearImgUrl = this.fileCommonUrl + img.lpCardRearImg;
        this.modal2 = false;
        //收到服务器信息，心跳重置
        this.reset();
      }
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.init();
        that.lockReconnect = false;
      }, 1000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function() {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) {
          //如果连接正常
          self.websock.send('heartCheck');
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function() {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    uploadImg() {
      //触发上传图片按钮
      this.$refs.avatarInput.dispatchEvent(new MouseEvent('click'));
      var file = document.getElementById('file');
      var image = document.querySelector('.noImg');
      file.onchange = function() {
        var fileData = this.files[0]; //获取到一个FileList对象中的第一个文件(File 对象)。这是我们上传的文件
        var reader = new FileReader();
        reader.readAsDataURL(fileData); //异步读取文件内容，结果用data:url的字符串形式表示
        /*当读取操作成功完成时调用*/
        reader.onload = function(e) {
          image.setAttribute('src', this.result);
        };
      };
    },
    // 获取企业信息
    getCompanyData: function() {
      this.$http
        .post({
          modeCode: 'YYpXas9qlSnJWer5Ru21Zm1bV77ZB6cl',
          sessionId: this.session.sessionId,
          userId: this.session.userId,
          enterpriseId: this.session.enterpriseId
        })
        .then((res) => {
          if (res.code == 1) {
            // 企业详细信息
            this.imgArr = res.data.enterpriseInfo.trcImg;
            this.information.orgId = res.data.enterpriseInfo.orgId;
            this.information.blNum = res.data.enterpriseInfo.blNum;
            this.information.orgName = res.data.enterpriseInfo.orgName;
            this.information.ownerTown = res.data.enterpriseInfo.ownerTown;
            // 开户行下拉
            this.bankList = res.data.bankList;
            this.cityList = res.data.townlist;
            this.enterpriseTypeList = res.data.enterpriseTypeList;
            this.information.enterpriseType = res.data.enterpriseInfo.enterpriseType;
            this.information.enterpriseCode = res.data.enterpriseInfo.enterpriseCode;
            if (res.data.enterpriseInfo.regFund) {
              this.information.regFund = res.data.enterpriseInfo.regFund.toString();
            }
            if (res.data.enterpriseInfo.regDate) {
              let time = res.data.enterpriseInfo.regDate.split(' ')[1];
              // 判断是否返回的带有时分秒，有的话截取没有的话直接赋值
              time ? (this.information.regDate = res.data.enterpriseInfo.regDate.split(' ')[0]) : (this.information.regDate = res.data.enterpriseInfo.regDate);
            }
            this.information.bankAccount = res.data.enterpriseInfo.bankAccount;
            this.information.address = res.data.enterpriseInfo.address;
            this.information.bankId = res.data.enterpriseInfo.bankId;
            this.information.postalCode = res.data.enterpriseInfo.postalCode;
            this.information.fax = res.data.enterpriseInfo.fax;
            this.information.enterpriseWeb = res.data.enterpriseInfo.enterpriseWeb;
            this.information.enterpriseProfile = res.data.enterpriseInfo.enterpriseProfile;
            this.information.zybankMerId = res.data.enterpriseInfo.zybankMerId;
            // 联系人信息
            this.contactsInfo.cpName = res.data.enterpriseInfo.cpName;
            this.contactsInfo.cpPhone = res.data.enterpriseInfo.cpPhone;
            this.contactsInfo.cpCardId = res.data.enterpriseInfo.cpCardId;
            this.contactsInfo.lpName = res.data.enterpriseInfo.lpName;
            this.contactsInfo.lpPhone = res.data.enterpriseInfo.lpPhone;
            this.contactsInfo.lpCardId = res.data.enterpriseInfo.lpCardId;
            this.contactsInfo.cpCardFrontImg = res.data.enterpriseInfo.cpCardFrontImg;
            this.contactsInfo.cpCardRearImg = res.data.enterpriseInfo.cpCardRearImg;
            this.contactsInfo.lpCardFrontImg = res.data.enterpriseInfo.lpCardFrontImg;
            this.contactsInfo.lpCardRearImg = res.data.enterpriseInfo.lpCardRearImg;
            if (res.data.enterpriseInfo.cpCardFrontImg) {
              this.cpCardFrontImgUrl = this.fileCommonUrl + res.data.enterpriseInfo.cpCardFrontImg;
            }
            if (res.data.enterpriseInfo.cpCardRearImg) {
              this.cpCardRearImgUrl = this.fileCommonUrl + res.data.enterpriseInfo.cpCardRearImg;
            }
            if (res.data.enterpriseInfo.lpCardFrontImg) {
              this.lpCardFrontImgUrl = this.fileCommonUrl + res.data.enterpriseInfo.lpCardFrontImg;
            }
            if (res.data.enterpriseInfo.lpCardRearImg) {
              this.lpCardRearImgUrl = this.fileCommonUrl + res.data.enterpriseInfo.lpCardRearImg;
            }
          }
        });
    },
    handleUpload(file) {
      const msg = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: 'other' //其他分组
        };
        let base64 = encodeURIComponent(file64);
        this.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            this.imgArr = res.msg;
          } else {
            this.$Message['error']({
              background: true,
              content: '上传失败，请重试'
            });
          }
        });
      };
      return false; // 阻止Upload的默认上传
    },
    // 上传法人身份证正面
    uploadlpCardFrontImg(file) {
      const msg = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: 'other' //其他分组
        };
        let base64 = encodeURIComponent(file64);
        that.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            that.lpCardFrontImgUrl = this.fileCommonUrl + res.msg;
            that.contactsInfo.lpCardFrontImg = res.msg;
          } else {
            that.$Message['error']({
              background: true,
              content: '上传失败，请重试'
            });
          }
        });
      };
      return false; // 阻止Upload的默认上传
    },
    // 上传法人身份证背面
    uploadlpCardRearImg(file) {
      const msg = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: 'other' //其他分组
        };
        let base64 = encodeURIComponent(file64);
        that.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            that.lpCardRearImgUrl = this.fileCommonUrl + res.msg;
            that.contactsInfo.lpCardRearImg = res.msg;
          } else {
            that.$Message['error']({
              background: true,
              content: '上传失败，请重试'
            });
          }
        });
      };
      return false; // 阻止Upload的默认上传
    },
    handleSubmit(name) {
      if (this.imgArr) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.step = 2;
            this.information.regDate = this.$timeChange(this.information.regDate);
          }
        });
      } else {
        this.$Message.error('请上传企业营业执照！');
        return;
      }
    },
    timeChange: function() {
      timeId = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          window.history.back(-1);
          clearInterval(timeId);
        }
      }, 1000);
    },
    gobig: function(url) {
      if (this.bigUrl.length != 0) {
        this.bigUrl = [];
      }
      this.isShowBig = true;
      this.bigUrl.push(url);
    },
    showModal2: function() {
      this.modal2 = true;
      // function getUUID() {
      // 	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      // 		return (c === "x" ?
      // 			(Math.random() * 16) | 0 :
      // 			"r&0x3" | "0x8"
      // 		).toString(16);
      // 	});
      // }
      // let uuid = getUUID()
      if (this.step == 1) {
        setTimeout(() => {
          this.$refs.qrcodeDiv.innerHTML = '';
          var that = this;
          console.log(that.session.sessionId);
          console.log(that.session.userId);
          let href = localStorage.getItem('platUrl') + '/#/' + 'uploadAuthertication?' + that.session.sessionId + '&' + that.session.userId;
          var qrcode = new QRCode(this.$refs.qrcodeDiv, {
            text: href, //二维码内容   url填后台给的链接
            width: 270, //控制二维码高度
            height: 270, //控制二维码宽度
            colorDark: '#000000', //控制二维码前景色
            colorLight: '#ffffff', //控制二维码背景色=
            correctLevel: QRCode.CorrectLevel.L //设置二维码容错率
          });
        }, 100);
      }
      if (this.step == 2) {
        setTimeout(() => {
          this.$refs.qrcodeDiv.innerHTML = '';
          var that = this;
          let href = localStorage.getItem('platUrl') + '/#/' + 'uploadCard?' + that.session.sessionId + '&' + that.session.userId;
          var qrcode = new QRCode(this.$refs.qrcodeDiv, {
            text: href, //二维码内容   url填后台给的链接
            width: 270, //控制二维码高度
            height: 270, //控制二维码宽度
            colorDark: '#000000', //控制二维码前景色
            colorLight: '#ffffff', //控制二维码背景色
            correctLevel: QRCode.CorrectLevel.L //设置二维码容错率
          });
        }, 100);
      }
    },
    submit() {
      this.$refs['contactsInfo'].validate((valid) => {
        if (valid) {
          //判断是否上传身份证
          if (!this.contactsInfo.cpCardFrontImg) {
            this.$Message['error']({
              background: true,
              content: '请上传联系人身份证正面！'
            });
            return;
          }
          if (!this.contactsInfo.cpCardRearImg) {
            this.$Message['error']({
              background: true,
              content: '请上传联系人身份证反面！'
            });
            return;
          }
          if (!this.contactsInfo.lpCardFrontImg) {
            this.$Message['error']({
              background: true,
              content: '法人身份证正面！'
            });
            return;
          }
          if (!this.contactsInfo.lpCardRearImg) {
            this.$Message['error']({
              background: true,
              content: '法人身份证反面！'
            });
            return;
          }
          this.information.trcImg = this.imgArr;
          let data = {
            ...this.information,
            ...this.contactsInfo,
            id: this.session.enterpriseId,
            modeCode: '8im72Ry90yanOBEZgLkE5TmOX9UzqnC9',
            sessionId: this.session.sessionId,
            userId: this.session.userId
          };
          this.$http.post(data).then((res) => {
            if (res.code == 1) {
              this.$Message['success']({
                background: true,
                content: '提交认证成功'
              });
              this.step = 3;
              this.timeChange();
            } else {
              this.$Message['error']({
                background: true,
                content: res.msg
              });
            }
          });
        }
      });
    },
    // 上传身份证正面
    uploadcpCardFront(file) {
      const msg = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: 'other' //其他分组
        };
        let base64 = encodeURIComponent(file64);
        that.$http.upload(data, base64).then((res) => {
          // 清除loading
          setTimeout(msg, 300);
          if (res.code == 1) {
            that.cpCardFrontImgUrl = this.fileCommonUrl + res.msg;
            that.contactsInfo.cpCardFrontImg = res.msg;
          } else {
            that.$Message['error']({
              background: true,
              content: '上传失败，请重试'
            });
          }
        });
      };
      return false; // 阻止Upload的默认上传
    },
    // 上传身份证反面
    uploadcpCardRearImg(file) {
      const msg = this.$Message.loading({
        content: '上传中...',
        duration: 0
      });
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let file64 = e.target.result;
        let data = {
          modeCode: 'DF6ylrACPgiTD0PGgs9F2l0yZHyiEO2M',
          sessionId: that.session.sessionId,
          userId: that.session.userId,
          fileName: encodeURIComponent(file.name),
          ocrType: 0,
          group: 'other' //其他分组
        };
        let base64 = encodeURIComponent(file64);
        that.$http.upload(data, base64).then((res) => {
          setTimeout(msg, 300);
          if (res.code == 1) {
            that.cpCardRearImgUrl = this.fileCommonUrl + res.msg;
            that.contactsInfo.cpCardRearImg = res.msg;
          } else {
            that.$Message['error']({
              background: true,
              content: '上传失败，请重试'
            });
          }
        });
      };
      return false; // 阻止Upload的默认上传
    }
  }
};
</script>

<style scoped lang="less">
#authentication {
  overflow: auto;
}

.contractBox {
  display: flex;
  align-items: center;
}

/deep/ .ivu-select-input {
  height: 48px;
}

/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

/deep/ .ivu-btn-primary {
  background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
  margin: 0 10px;
}

/deep/ .ivu-modal-header {
  background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
  border-radius: 10px 10px 0 0;
  overflow: hidden;
  height: 48px;
}

/deep/ .ivu-modal-content {
  border-radius: 10px;
}

/deep/ .ivu-modal-close .ivu-icon-ios-close {
  color: white;
}

/deep/.ivu-btn-primary.sbumit {
  display: block;
  background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
  border: 1px solid #b2c9ff;
  border-radius: 8px;
  width: 368px;
  height: 48px;
  margin: auto;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0.3px;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 48px;
  line-height: 48px;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  height: 48px;
  line-height: 48px;
}

#authentication {
  header {
    background: #f7f9fd;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #616c84;
    letter-spacing: -0.43px;
  }

  section {
    margin: 20px auto;

    .title {
      margin: 20px 0;

      .left {
        font-family: PingFangSC-Regular;
        color: #252a37;
        letter-spacing: 0.39px;

        h2 {
          margin-left: 15px;
        }
      }

      span {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #2c59c3;
        letter-spacing: 0.26px;
        cursor: pointer;
      }
    }

    /* 步骤条 */
    .progress {
      margin: 20px auto;
      border-bottom: 2px solid #d7dce7;
      padding: 0 200px;
      height: 35px;
      line-height: 30px;
      cursor: pointer;
      position: relative;

      .backBox {
        position: absolute;
        top: 0;
        left: 20px;
        width: 100px;
      }

      .item {
        width: 210px;
        display: flex;
        align-items: center;
        padding: 5px 12px;

        span {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #252a37;
          margin-left: 10px;
          letter-spacing: 0.29px;
        }

        /* 步骤序号 */
        .step {
          width: 24px;
          height: 24px;
          line-height: 24px;
          background: #b0b5c1;
          color: #fff;
          border-radius: 50%;
          text-align: center;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.29px;
        }
      }

      .line {
        margin: 0 30px;
      }

      /* 进度条激活样式 */
      .item.active {
        border-bottom: 2px solid #2c59c3;
        margin-bottom: -2px;

        .step {
          background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
        }
      }

      .stepFinish img {
        vertical-align: middle;
      }
    }

    .progressBox {
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0 10px 90px 0 rgba(29, 42, 67, 0.05);
      padding: 20px;

      .head {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #2c59c3;
        letter-spacing: 0.36px;
        text-align: center;
        font-weight: 600;
      }

      .progressContent {
        width: 860px;
        margin: 20px auto;
        padding: 15px 0;
        border-top: 1px solid #ebedf3;

        // 企业信息
        .license {
          background: #ffffff;
          border: 1px solid #ccd1dd;
          border-radius: 4px;
          width: 368px;
          height: 210px;
          margin: 5px 0;
          text-align: center;

          .noImg {
            width: 320px;
            height: 180px;
            margin: 10px 10px;
          }
        }

        .msg {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #616c84;
          letter-spacing: 0.21px;
        }

        .upload {
          padding: 0;
          width: 117px;
          height: 26px;
          line-height: 26px;
          border: 0;
          outline: none;
        }

        .upload:first-child {
          background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
        }

        /deep/ .ivu-btn-primary {
          background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
          margin: 0 10px;
        }

        // 表单label样式
        /deep/ .ivu-form .ivu-form-item-label {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #616c84;
          letter-spacing: 0.26px;
          line-height: 20px;
        }

        .ivu-form-item {
          width: 368px;
        }

        /deep/ .ivu-input {
          height: 48px;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        }

        /deep/ .ivu-select-single .ivu-select-selection {
          height: 48px;
          line-height: 48px;
          box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        }

        /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
        .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
          line-height: 48px;
        }

        /deep/ .ivu-date-picker {
          display: block;
        }

        /deep/ .ivu-input-suffix {
          line-height: 48px;
        }

        /deep/ .ivu-select-dropdown {
          top: 84px !important;
        }

        .next {
          display: block;
          width: 368px;
          margin: auto;
          height: 48px;
        }

        // 联系人信息
        .imgBox {
          border-top: 1px solid #ebedf3;

          .imgMsg {
            margin: 10px 0;

            .txt {
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #2c59c3;
              letter-spacing: 0.25px;
              font-weight: 600;
              margin-right: 10px;
            }
          }

          .must {
            color: #ed4014;
            margin-right: 4px;
            font-size: 12px;
            display: inline-block;
            font-family: SimSun;
          }
        }
      }

      .uploadBut {
        background-image: linear-gradient(180deg, #5792e3 0%, #406dd8 100%);
        border: 1px solid #285ed3;
        border-radius: 4px;
        color: white;
        width: 117px;
        height: 26px;
        margin-top: 4px;
        margin-left: 16.5px;
      }

      .submitBox {
        width: 500px;
        margin: 60px auto 40px;
        display: flex;
        align-items: center;

        .backBut {
          width: 200px;
          height: 48px;
          border: 1px solid #2255ce;
          border-radius: 8px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #2255ce;
          letter-spacing: 0.3px;
        }

        .nosubmit {
          cursor: pointer;
          background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
          border: 1px solid #b2c9ff;
          border-radius: 8px;
          width: 280px;
          height: 48px;
          text-align: center;
          line-height: 48px;
          margin: auto;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0.3px;
        }
      }

      // 完成
      .completeBox {
        width: 860px;
        margin: 20px auto;

        .completeTitle {
          width: 45%;
          margin: 0 auto 30px;

          img {
            margin: 0 20px;
          }

          h2 {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #4a4a4a;
            letter-spacing: 0.45px;
          }
        }

        .completeContent {
          padding: 30px;
          border-top: 1px solid #ebedf3;
          width: 860px;
          text-align: center;

          .textBox {
            width: 75%;
            margin: auto;

            h3 {
              font-family: PingFangSC-Medium;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
              margin: 10px 0;
            }

            .completeTxt {
              text-align: left;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }
          }

          .reduce {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #878787;
            letter-spacing: 0;
            margin: 150px 0 20px;
          }

          .back {
            width: 124px;
            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #f5f5f5 100%);
            border: 1px solid #d8d8d8;
            border-radius: 4px;
          }
        }
      }
    }
  }

  .alert {
    width: 600px;
    height: 466px;
    margin-top: -233px;
    margin-left: -300px;

    .alertContent {
      text-align: center;
      margin: 60px auto 0;

      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0.22px;
      }
    }
  }

  .bigImg {
    text-align: center;
    position: absolute;
    left: 35%;
    top: 12%;
  }

  .close {
    width: 60px;
    height: 60px;
    line-height: 60px;
    float: right;
    background: url('../assets/imgs/authentication/closeBg.png') no-repeat;
    text-align: center;
  }
}

/deep/ .ivu-input[disabled] {
  color: #515a6e;
}
</style>
